import { render, staticRenderFns } from "./EmailsItem.vue?vue&type=template&id=84d6fde0&scoped=true"
import script from "./EmailsItem.vue?vue&type=script&lang=js"
export * from "./EmailsItem.vue?vue&type=script&lang=js"
import style0 from "./EmailsItem.vue?vue&type=style&index=0&id=84d6fde0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d6fde0",
  null
  
)

export default component.exports